import {IFormArr} from '@/components/types'

export const basicFormConfig: IFormArr = {
  iForms: [
    {
      formItems: [
        {
          field: 'customerName',
          type: 'input',
          label: '客户姓名',
          placeholder: '请输客户姓名'
        },
        {
          field: 'customerNick',
          type: 'input',
          label: '客户昵称',
          placeholder: '请输客户昵称'
        },
        {
          field: 'sex',
          type: 'select',
          label: '性别',
          placeholder: '请选择性别'
        }
      ]
    },
    {
      formItems: [
        {
          label: '开发信息',
          field: 'developInfo',
          type: 'alltextarea',
          placeholder: '请输入开发信息'
        },
        {
          label: '客户信息',
          field: 'customerInfo',
          type: 'alltextarea',
          placeholder: '请输入客户信息'
        }
      ]
    }
  ]
}
